import React from 'react';

const INTEGRATION_SERVICES = [
  'Битрикс24',
  'amoCRM',
  '1С',
  'Jira',
  'Slack',
  'Google Workspace',
  'Microsoft Teams',
  'Tilda',
  'МойСклад',
  'GetCourse',
  'Usedesk',
  'Telegram',
  'Notion',
  'Confluence',
  'SAP',
  'Salesforce',
  'HubSpot',
  'Zendesk',
  'Freshdesk',
  'Mailchimp',
  'Unisender',
  'Ozon Seller',
  'Wildberries',
  'Яндекс Метрика',
  'Google Sheets',
  'Airtable',
  'Trello',
  'Asana',
  'ClickUp',
  'Power BI',
];

const LandingIntegrationsMarquee = ({ className = '' }) => {
  const items = [...INTEGRATION_SERVICES, ...INTEGRATION_SERVICES];

  return (
    <div className={`overflow-hidden relative w-full ${className}`}>
      <div className="flex animate-scroll-left w-max">
        {items.map((name, idx) => (
          <div
            key={`${name}-${idx}`}
            className="flex-shrink-0 mx-3 md:mx-4 rounded-full border border-border/60 bg-card px-5 py-2.5 md:px-6 md:py-3"
          >
            <span className="text-sm md:text-base font-medium text-foreground/80 whitespace-nowrap">
              {name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LandingIntegrationsMarquee;
